import { Constants } from '@src/app/commons/Constants';
import { DEBUG } from '@src/DEBUG';
DEBUG.open ( '/xs/controllers/defaults' );

import { XsBaseClass } from '../controllers/base.class';

// const Hash = require('object-hash');

/*
  XsDefaults reads in data / properties from items, and flags whether we've collected those defaults or not
*/

export class XsDefaults extends XsBaseClass {

  debugId:string = 'DEFAULTS';

  store:any = {};

  constructor ( config:any = {}) {
    super(config);

    if ( this.debug ) { console.log( this.debugId + ' :: CONSTRUCTOR'); }
    DEBUG.log ( '/xs/controllers/defaults' );

    if ( this._config ) {
      this.init();
    }
    
  }

  init() {
    if ( this._config['items'] ) {
      this._config['items'].forEach ( item => {
        this.store[item] = {
          value: null, fetched: false
        }
      });
    }
    if ( this.debug ) { console.log('%c ** init()', Constants._pink, this.store ); }
  }

  readFromItem ( item:any = null ) {
    if ( item && item['__saved_defaults'] ) {
      Object.keys( item['__saved_defaults'] ).forEach ( key => {
        if ( this.store[key] ) {
          this.store[key].value = JSON.parse( item['__saved_defaults'][key] );
        }
      });
    }
    if ( this.debug ) { console.log('%c ** readFromItem()', Constants._pink, item, this.store ); }
  }

  writeToItem ( item:any = null ) {
    if ( item ) {
      if ( !item['__saved_defaults'] ) {
        item['__saved_defaults'] = {};
      }
      Object.keys( this.store ).forEach ( key => {
        if ( this.store[key] && this.store[key].value ) {
          item['__saved_defaults'][key] = JSON.stringify( this.store[key].value );
        }
      });
    }
    if ( this.debug ) { console.log('%c ** writeToItem()', Constants._pink, item, this.store ); }
  }

  put ( key:string = null, data:any = null ) {
    if ( this.debug ) { console.log('%c ** put()', Constants._pink, key ); }
    if ( this.store[key] ) {
      this.store[key].value = data;
      this.store[key].fetched = true; // putting data in dirties the cache, so no need to fetch it
    }
    return null;
  }

  fetch ( key:string = null, forced:boolean = false ) {
    if ( this.debug ) { console.log('%c ** fetch()', Constants._pink, key ); }
    if ( this.store[key] && ( !this.store[key].fetched || forced ) ) {
      this.store[key].fetched = true;
      return this.store[key].value;
    }
    return null;
  }

  isFetched ( key:string = null ) {
    if ( this.store[key] ) {
      return this.store[key].fetched;
    }
    return false;
  }

  hasValue ( key:string = null ) {
    if ( this.store[key] && this.store[key].value ) {
      return true
    }
    return false;
  }

}
